import React from "react";
import { motion } from "framer-motion";
import * as analytics from "@/lib/analytics";

const EVENTS = [
  {
    title: "מונדיאל 2026",
    desc: "הזדמנות של פעם בחיים",
    image: "/images/giveaway/shutterstock_2764805163.png",
  },
  {
    title: "הופעות הענק",
    desc: "המבוקשות בעולם",
    image: "/images/giveaway/shutterstock_2764810243.jpg",
  },
  {
    title: "פסטיבלי מוזיקה",
    desc: "בינלאומיים",
    image: "/images/giveaway/shutterstock_2764811055.jpg",
  },
  {
    title: "חוויות VIP",
    desc: "אירועי ספורט אקסקלוסיביים",
    image: "/images/giveaway/shutterstock_2764815005.jpg",
  },
];

export default function WhatsInside({ onCTA }) {
  return (
    <section className="py-20 md:py-28" style={{ background: "#0E0E0E" }}>
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <h2
            className="font-bold text-white mb-4"
            style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)" }}
          >
            מה מחכה לכם בפנים?
          </h2>
          <p className="text-base md:text-lg" style={{ color: "#FFFFFF" }}>
            גישה מועדפת לאירועים הגדולים ביותר על הגלובוס
          </p>
        </motion.div>

        <div className="space-y-5 mb-10">
          {EVENTS.map((ev, i) => (
            <motion.div
              key={ev.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="relative rounded-2xl overflow-hidden"
              style={{ height: "220px", border: "1px solid #4d4d4d" }}
            >
              <img
                src={ev.image}
                alt={ev.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)",
                }}
              />
              <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-8">
                <h3 className="text-2xl md:text-3xl font-bold mb-1" style={{ color: "#D7FF37" }}>
                  {ev.title}
                </h3>
                <p className="text-base text-white">
                  {ev.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-lg font-bold mb-8" style={{ color: "#D7FF37" }}>
            הכל במחיר המקורי. תמיד.
          </p>
          <button
            onClick={() => { analytics.trackCTA("whats_inside", { position: "mid" }); onCTA(); }}
            className="px-8 py-3.5 rounded-full font-bold text-base cursor-pointer transition-all duration-200 hover:scale-105"
            style={{
              background: "#D7FF37",
              color: "#121212",
            }}
          >
            קחו אותי להרשמה חינמית
          </button>
        </motion.div>
      </div>
    </section>
  );
}
